import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {
  Guardians,
  GuardiansQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL

const getFilter = (query: any): Promise<GuardiansQueryResponse> => {
  return axios
    .get(`${API_URL}/admin/videos/filter`, {params: query})
    .then((d: AxiosResponse<GuardiansQueryResponse>) => {
      return d.data;
    })
}

const update = (meetings: Guardians): Promise<Guardians | undefined> => {
  return axios
    .post(`${API_URL}/admin/videos/update/${meetings.id}`, meetings)
    .then((response: AxiosResponse<Response<Guardians>>) => response.data)
    .then((response: Response<Guardians>) => response.data)
}

const deleteVideo = (id: number): Promise<void> => {
  return axios
    .post(`${API_URL}/admin/videos/delete/${id}`);
}


const iaAnalyseVideo = (id: number): Promise<Guardians | undefined> => {
  return axios
    .post(`${API_URL}/admin/videos/ia-analyse`, {
      id
    }).then((response: AxiosResponse) => response.data)
    .then((data) => {
      return {
        id: data.id,
        children_id: data.children_id,
        guardian_id: data.guardian_id,
        video_name: data.video_name,
        position: data.position,
      } as Guardians
    });
}


const createIaFeedback = (id: ID, type: string, value: string): Promise<void> => {
  return axios
    .post(`${API_URL}/admin/videos/ia-feedback/create`, {
      id,
      type,
      value
    }).then((response: AxiosResponse) => response.data)
}





export {
  update,
  getFilter,
  deleteVideo,
  iaAnalyseVideo,
  createIaFeedback
}
